
































































































































import { Component, PropSync, Vue } from 'vue-property-decorator';

import FlagshipProfilingStepEmploymentSituationViewModel
  from '@/vue-app/view-models/components/flagship/flagship-profiling/flagship-profiling-step-employment-situation-view-model';

@Component({ name: 'FlagshipProfilingStepEmploymentSituation' })
export default class FlagshipProfilingStepEmploymentSituation extends Vue {
  @PropSync('isLoading', { type: Boolean, required: false, default: false })
  synced_is_loading!: boolean;

  @PropSync('showEmploySituationSection', {
    type: Boolean,
    required: false,
    default: true,
  })
  synced_show_employee_situation_section!: boolean;

  @PropSync('showStudyLevel', {
    type: Boolean,
    required: false,
    default: true,
  })
  synced_show_study_level_section!: boolean;

  @PropSync('backButtonText', {
    type: String,
    required: false,
    default: 'Regresar',
  })
  synced_back_button_text!: string;

  @PropSync('continueButtonText', {
    type: String,
    required: false,
    default: 'Continuar',
  })
  synced_continue_button_text!: string;

  flagship_situation_view_model = Vue.observable(
    new FlagshipProfilingStepEmploymentSituationViewModel(this),
  );

  created() {
    this.flagship_situation_view_model.initialize(this.synced_show_study_level_section, this
      .synced_show_employee_situation_section);
  }
}
